module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSO BY"), _c('br'), _vm._v(" "), _c('br')]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MASSIMO CARLOTTO")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781933372051/the-goodbye-kiss",
      "target": "_blank"
    }
  }, [_vm._v("The Goodbye Kiss")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781933372181/death-s-dark-abyss",
      "target": "_blank"
    }
  }, [_vm._v("Death’s Dark Abyss")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781933372259/the-fugitive",
      "target": "_blank"
    }
  }, [_vm._v("The Fugitive")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781933372914/poisonville",
      "target": "_blank"
    }
  }, [_vm._v("Poisonville")])]), _vm._v(" (with Marco Videtta)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781933372808/bandit-love",
      "target": "_blank"
    }
  }, [_vm._v("Bandit Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609451141/at-the-end-of-a-dull-day",
      "target": "_blank"
    }
  }, [_vm._v("At the End of a Dull Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609452681/gang-of-lovers",
      "target": "_blank"
    }
  }, [_vm._v("Gang of Lovers")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4307ddac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/for-all-the-gold-in-the-world_00000.vue
// module id = 60
// module chunks = 0